import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { signUpSelector } from '../../../store/selectors/signUpSelector';
import { setSignUp, clearSignUp } from '../../../store/modules/signUp';
import { useTranslations } from '../../../utility/useTranslations';
import SignUpForm from '../../shared/signUpForm';
import BackgroundContainer from '../../shared/backgroundContainer';
import { useCookieConsent } from '../../../utility/hooks';
import { APP_PAGES } from '../../../constants/pages';
import { getFields, SIGN_UP_FORM_FIELD_NAMES } from './config';

const SignUpPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translations = useTranslations(APP_PAGES.SIGN_UP);

  const { signUp } = useSelector(signUpSelector);
  const fields = getFields(translations);

  const { clearCookies, hasPermission } = useCookieConsent(CookieConsent);

  useEffect(() => {
    window.addEventListener('unload', clearCookies);

    return () => {
      window.removeEventListener('unload', clearCookies);
    };
  }, [clearCookies]);

  return (
    <BackgroundContainer
      translations={translations.authContainer}
      onOpenCookieSettings={() => CookieConsent.showPreferences()}
      signUpPage
    >
      <SignUpForm
        translations={translations}
        navigate={navigate}
        dispatch={dispatch}
        initialData={{
          ...signUp,
          [SIGN_UP_FORM_FIELD_NAMES.PREFERENCE]: true,
        }}
        fields={fields}
        hasPermission={hasPermission}
        setSignUp={setSignUp}
        clearSignUp={clearSignUp}
      />
    </BackgroundContainer>
  );
};

export default SignUpPage;
